<template>

    <tr class="c-summary_value">
        <td class="c-summary_value__td c-summary_value__td--label">{{ label }}</td>
        <td class="c-summary_value__td c-summary_value__td--value">
            <slot></slot>
        </td>
    </tr>

</template>


<script>

export default {

    name: 'SummaryValue',

    props: {
        label: String
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-summary_value {
    &__td {
        padding: .3rem 0;

        &--label {
            color: $c-secondary;

            &:after {
                content: ':';
            }
        }
        &--value {
            padding: 0 1.4rem;
            color: $c-third;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

</style>
